module.exports = __webpack_public_path__ + "static/media/whatsapp.fbca2abb.svg";